import ninegrid from "../index.js";

export class ngCellSelection
{
	#owner;
	#onSelectChanged;
	#interval;
	
	constructor(owner) {

		this.#owner = owner;

		this.#onSelectChanged = new CustomEvent('selectchanged', { bubbles: true, detail: {} });
		
		
		this.selected = {
			//fixed : false,
			currentRow	: -1,
			currentMatrixRow	: -1,
			currentCol	: -1,
			startRow	: -1,
			startCol	: -1,
			endRow		: -1,
			endCol		: -1,
			oldStartRow	: -1,
			oldStartCol	: -1,
			oldEndRow	: -1,
			oldEndCol	: -1,
			clear		:
				() => {
					this.selected.startRow = this.selected.endRow = this.selected.startCol = this.selected.endCol = -1;
					ninegrid.j.querySelectorAll("th,td", this.#owner.body).removeClass("selected").removeClass("selected-area").removeClass("selected-top").removeClass("selected-bottom").removeClass("selected-left").removeClass("selected-right");
				},
		}

		this.#init();
		
		//this.#onRowPosChanged = new CustomEvent('rowposchanged', { bubbles: true, detail: {} });
	};
	
	get type() {
		return this.#owner.getAttribute("select-type");
	};
	set type(v) {
		if (!Object.values(ninegrid.SELECTTYPE).includes(v)) throw `invalid select type : ${v}`;

		Object.values(ninegrid.SELECTTYPE).forEach(m => { ninegrid.j.querySelectorAll(".ng-table", this.#owner.body).removeClass(`select-type-${m}`); });
		ninegrid.j.querySelectorAll(".ng-table", this.#owner.body).addClass(`select-type-${v}`);
		this.#owner.cell.refresh();
	};
	
	
	getActiveCell = () => {
		var row = this.selected.currentRow;
		var col = this.selected.currentCol;
		var subRowIndex = parseInt(this.selected.currentMatrixRow % this.#owner.template.length);

		var el = $(`tbody.bindable [data-row=${row}]`, this.#owner.body).find(`[data-col=${col}]`).not(".dummy").eq(subRowIndex);

		return (el.length > 0)? el[0] : null;
	};
	

	refresh = () => {
		
		switch (this.type) {
		case ninegrid.SELECTTYPE.ROW:
			
			this.selected.startRow	= parseInt(this.#owner.row.at * this.#owner.template.length);
			this.selected.endRow	= this.selected.startRow + this.#owner.template.length - 1;

			var cols = [];
			$(`tbody tr[data-row=${parseInt(this.selected.startRow / this.#owner.template.length)}] td`, this.#owner.body).not(".dummy").not(".first").each((i,el) => { if (parseInt(ninegrid.j.querySelectorAll(el).attr("tabindex")) >= 0) cols.push(Number(el.dataset.col)); });

			this.selected.startCol	= (cols.length > 0) ? Math.min.apply(null, cols) : -1;
			this.selected.endCol	= (cols.length > 0) ? Math.max.apply(null, cols) : -1;
			
			break;
			
		case ninegrid.SELECTTYPE.ROWS:
			this.selected.startRow	= parseInt(this.selected.startRow / this.#owner.template.length) * this.#owner.template.length;
			this.selected.endRow	= parseInt(this.selected.endRow / this.#owner.template.length) * this.#owner.template.length - 1 + this.#owner.template.length;

			this.selected.startCol	= this.#owner.firstCol;//Math.min.apply(null, cols);
			this.selected.endCol	= this.#owner.lastCol;//Math.max.apply(null, cols);
		break;
			
		case ninegrid.SELECTTYPE.COL:
			this.selected.startRow	= 0;
			this.selected.endRow	= parseInt(this.#owner.data.count() * this.#owner.template.length - 1);
			this.selected.endCol	= this.selected.startCol;
			
			var cells = [];
			this.#owner.template.each((i,tr) => {
				tr.querySelectorAll("th,td").forEach(cell => {
					const col = parseInt(cell.dataset.col);
					const colSpan = parseInt(cell.colSpan || 1);
					
					if (this.selected.startCol >= col && this.selected.endCol <= (col + colSpan - 1)) {
						cells.push(cell);
					}
				})
			});
			
			var cols = [];
			cells.forEach(cell => {
				cols.push(parseInt(cell.dataset.col));
				cols.push(parseInt(cell.dataset.col) + parseInt(cell.colSpan||1) - 1);
			});
			
			this.selected.startCol	= Math.min.apply(null, cols);
			this.selected.endCol	= Math.max.apply(null, cols);
			
			break;
			
		case ninegrid.SELECTTYPE.COLS:

			this.selected.startRow	= 0;
			this.selected.endRow	= parseInt(this.#owner.data.count() * this.#owner.template.length - 1);
			//this.selected.endCol	= this.selected.startCol;
			
			var cells = [];
			this.#owner.template.each((i,tr) => {
				tr.querySelectorAll("th,td").forEach(cell => {
					const col = parseInt(cell.dataset.col);
					const colSpan = parseInt(cell.colSpan || 1);
					
					if ( (this.selected.startCol >= col && this.selected.startCol <= (col + colSpan - 1)) || (this.selected.endCol >= col && this.selected.endCol <= (col + colSpan - 1)) ) {
						cells.push(cell);
					}
				})
			});
			
			var cols = [];
			cells.forEach(cell => {
				cols.push(parseInt(cell.dataset.col));
				cols.push(parseInt(cell.dataset.col) + parseInt(cell.colSpan||1) - 1);
			});
			
			this.selected.startCol	= Math.min.apply(null, cols);
			this.selected.endCol	= Math.max.apply(null, cols);
			
			break;
			
		case ninegrid.SELECTTYPE.CELL:
			this.selected.endRow = this.selected.startRow;
			this.selected.endCol = this.selected.startCol;
			break;
			
		case ninegrid.SELECTTYPE.AREA:
			break;
			
		case ninegrid.SELECTTYPE.NONE:
			this.selected.startRow = this.selected.endRow = this.selected.startCol = this.selected.endCol = -1;
			break;
		}
		
		
		ninegrid.j.querySelectorAll("th,td", this.#owner.body).removeClass("active").removeClass("multi-selected").removeClass("selected").removeClass("selected-current").removeClass("selected-area").removeClass("selected-top").removeClass("selected-bottom").removeClass("selected-left").removeClass("selected-right");

		ninegrid.j.querySelectorAll(".selected-current", this.#owner.body).removeClass("selected-current");
		ninegrid.j.querySelectorAll(`tr[data-row="${this.selected.currentRow}"] ng-row-indicator`, this.#owner.body).addClass("selected-current");
		
		//var row = parseInt(this.selected.currentRow / this.#owner.template.length);
		ninegrid.j.querySelectorAll(`.col-indicator[data-col="${this.selected.currentCol}"]`, this.#owner.body).addClass("selected-current");
		$(`tr[data-row="${this.selected.currentRow}"] ng-row-indicator`, this.#owner.body).closest("th,td").addClass("selected-current");
		
		var activeCell = this.getActiveCell();
		if (activeCell) ninegrid.j.querySelectorAll(activeCell).addClass("active");

		$("tbody th,tbody td", this.#owner.body).each((index, td) => {
			var tdCol	= parseInt(td.dataset.col);
			var row 	= (parseInt(td.dataset.row) * this.#owner.template.length) + (td.closest("tr").sectionRowIndex % this.#owner.template.length);
			
			if (row == this.selected.currentMatrixRow && tdCol == this.selected.currentCol) {
				//ninegrid.j.querySelectorAll(td).addClass("active");
			}
			
			if (row + td.rowSpan - 1 >= this.selected.startRow && row <= this.selected.endRow && tdCol+td.colSpan-1 >= this.selected.startCol && tdCol <= this.selected.endCol) {
				
				ninegrid.j.querySelectorAll(td).addClass("selected");//.addClass("selected-area");
				
				if (this.selected.startRow == this.selected.endRow && this.selected.startCol == this.selected.endCol) {
					ninegrid.j.querySelectorAll(td).addClass("selected-top").addClass("selected-bottom").addClass("selected-left").addClass("selected-right");
				}
				else {
					if (row == this.selected.startRow)				ninegrid.j.querySelectorAll(td).addClass("selected-top");
					if (row+td.rowSpan-1 == this.selected.endRow)	ninegrid.j.querySelectorAll(td).addClass("selected-bottom");
					if (tdCol == this.selected.startCol)			ninegrid.j.querySelectorAll(td).addClass("selected-left");
					if (tdCol+td.colSpan-1 == this.selected.endCol)	ninegrid.j.querySelectorAll(td).addClass("selected-right");
					ninegrid.j.querySelectorAll(td).addClass("multi-selected");
				}
			}
		});

		$("tbody.bindable tr", this.#owner.body).each((index, tr) => {
			
			var td = tr.querySelector("ng-row-indicator");
			if (td) {
				td = td.closest("th,td");
				var row	= parseInt(td.dataset.row);

				for (var i = 0; i < td.rowSpan; i++) {
					var row = parseInt(td.dataset.row) * this.#owner.template.length + tr.sectionRowIndex % this.#owner.template.length + i;//tr.sectionRowIndex + this.#owner.dataManager.viewRecords.rawIndex * this.#owner.template.length;
					if (row >= this.selected.startRow && row <= this.selected.endRow) {
						ninegrid.j.querySelectorAll(td).addClass("selected-area");
					}
				}
			}
		});
		
		
		for (var i = this.selected.startCol; i <= this.selected.endCol; i++) {
			ninegrid.j.querySelectorAll(`.col-indicator[data-col="${i}"]`, this.#owner.body).addClass("selected-area");
		}
		
		if (this.selected.oldStartRow != this.selected.startRow || this.selected.oldEndRow != this.selected.endRow ||
			this.selected.oldStartCol != this.selected.startCol || this.selected.oldEndCol != this.selected.endCol) {
			
			this.#onSelectChanged.oldStartRow	= this.selected.oldStartRow;
			this.#onSelectChanged.oldEndRow		= this.selected.oldEndRow;
			this.#onSelectChanged.oldStartCol	= this.selected.oldStartCol;
			this.#onSelectChanged.oldEndCol		= this.selected.oldEndCol;
			this.#onSelectChanged.startRow		= this.selected.startRow;
			this.#onSelectChanged.endRow		= this.selected.endRow;
			this.#onSelectChanged.startCol		= this.selected.startCol;
			this.#onSelectChanged.endCol		= this.selected.endCol;

			this.#owner.dispatchEvent(this.#onSelectChanged);
		}
		
		this.selected.oldStartRow	= this.selected.startRow;
		this.selected.oldEndRow		= this.selected.endRow;
		this.selected.oldStartCol	= this.selected.startCol;
		this.selected.oldEndCol		= this.selected.endCol;
	};
	
	resetEvent = () => {
		$(".ng-table tbody.bindable", this.#owner.body)
			.off("mousedown", "th,td", this.#onMouseDown)
			.on("mousedown", "th,td", this.#onMouseDown);
	}
	
	#init = () => {
		this.resetEvent();
	};
	
	
		
	#onMouseDown = (e) => {

		if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return;
		//if (!this.ready) return;

		const fromTD	= e.target.closest("th,td");
		const fromTR	= fromTD.closest("tr");
		const startRow	= (parseInt(fromTD.dataset.row) * this.#owner.template.length + fromTR.sectionRowIndex % this.#owner.template.length);
		const startCol	= parseInt(fromTD.dataset.col);
		
		this.selected.currentCol = fromTD.dataset.col;
		this.selected.currentRow = fromTD.dataset.row;
		this.selected.currentMatrixRow = parseInt(fromTD.dataset.row * this.#owner.template.length) + parseInt(fromTD.closest("tr").sectionRowIndex % this.#owner.template.length);
		

		var prev = { row: -1, col: -1 };

		const onMouseMove = (e) => {
			//if (!this.#dragging) return;

			const toTD	= e.target.closest("th,td");
			const toTR	= toTD.closest("tr");
			
			if (toTR.sectionRowIndex == prev.row && toTD.dataset.col == prev.col) return;
			if ($(toTD).find("NG-ROW-INDICATOR").length > 0) return;
	
			
			const endRow		= (parseInt(toTD.dataset.row) * this.#owner.template.length + toTR.sectionRowIndex % this.#owner.template.length);
			const endCol		= parseInt(toTD.dataset.col);
			
			this.selectArea(startRow, startCol, endRow, endCol);
			
			prev = { row: toTR.sectionRowIndex, col: toTD.dataset.col }
		}
		
		const onMouseUp = (e) => {
			
			this.#owner.body.querySelector("ng-vscrollbar").stopScroll();
			
			clearInterval(this.#interval);
			
			$(".ng-table tbody.bindable", this.#owner.body).off("mousemove", onMouseMove);
			$(".ng-table tbody.bindable", this.#owner.body).off("mouseenter", onMouseEnter);
			$(".ng-table tbody.bindable", this.#owner.body).off("mouseleave", onMouseLeave);
			$(document).off("mousemove", onMouseOutMove);
			
			$(document).off('mouseup', onMouseUp);
		}
		
		const onMouseEnter = (e) => {
			clearInterval(this.#interval);
			$(document).off("mousemove", onMouseOutMove);
			//$(".ng-table tbody.bindable", this.#owner.body).on("mousemove", onMouseMove);
		};
		
		const onMouseLeave = (e) => {
			
			const container = $(".ng-container-body", this.#owner.body);
			const thead = container.find("thead");
			const tfoot = container.find("tfoot");
			
			var ypos;
			if (parseInt(e.pageY) >= parseInt(container.offset().top + container.height() - tfoot.height())) {
				ypos = 1;
			}
			else if (parseInt(e.pageY) <= parseInt(container.offset().top + thead.height())) {
				ypos = -1;
			}

			this.selected.col = this.selected.startCol;
			
			if (ypos) {
				$(document).on("mousemove", onMouseOutMove);
				
				this.#interval = setInterval(() => {
					if (ypos > 0) {
						
						this.selected.endRow = container.find("tbody.bindable tr:last-child")[0].sectionRowIndex + this.#owner.dataManager.viewRecords.rawIndex * this.#owner.template.length;
						
						const row1 = parseInt(this.selected.startRow / this.#owner.template.length);
						const row2 = parseInt(this.selected.endRow / this.#owner.template.length);
						if (row1 != row2) {
							//this.selected.startRow	= Math.floor(this.selected.startRow / this.#owner.template.length) * this.#owner.template.length;
							this.selected.endRow	= Math.floor(this.selected.endRow / this.#owner.template.length) * this.#owner.template.length + this.#owner.template.length - 1;
						}
						
						if (this.selected.endRow > parseInt(this.#owner.data.count() * this.#owner.template.length) - 1) {
							this.selected.endRow = parseInt(this.#owner.data.count() * this.#owner.template.length) - 1;
						}
					} else {
						
						this.selected.startRow = container.find("tbody.bindable tr:first-child")[0].sectionRowIndex + this.#owner.dataManager.viewRecords.rawIndex * this.#owner.template.length - this.#owner.template.length;

						const row1 = parseInt(this.selected.startRow / this.#owner.template.length);
						const row2 = parseInt(this.selected.endRow / this.#owner.template.length);
						if (row1 != row2) {
							this.selected.startRow	= Math.floor(this.selected.startRow / this.#owner.template.length) * this.#owner.template.length;
							//this.selected.endRow	= Math.floor(this.selected.endRow / this.#owner.template.length) * this.#owner.template.length + this.#owner.template.length - 1;
						}
						
						if (this.selected.startRow < 0) {
							this.selected.startRow = 0;
						}
					}
					
					this.#owner.scrollBy(ypos);
				}, 500);
			}
		};
		
		const onMouseOutMove = (e) => {
			
			//$(".ng-table tbody.bindable", this.#owner.body).off("mousemove", onMouseMove);
			
			//if (!this.#dragging) return;
			//.this.selected.startRow = this.selected.row;
			
			var td;
			$(".col-indicator", this.#owner.body).each((index,el) => {
				var l = $(el).offset().left;
				var w = $(el).width();
				if (e.pageX > l && e.pageX < l + w) {
					td = el;
					return false;
				}
			});

			if (td) {
				let col = parseInt(td.dataset.col);
				
				if (this.#owner.body.querySelector(`tbody.bindable [data-col="${col}"] ng-row-indicator`)) return;
				
				$("th,td", this.#owner.template).each((i,el) => {
					if (col >= parseInt(el.dataset.col) && col <= parseInt(el.dataset.col) + el.colSpan - 1) {
						col = (col >= startCol) ? Math.max(col, parseInt(el.dataset.col) + el.colSpan - 1) : Math.min(col, parseInt(el.dataset.col));
					}
				});
				
				if (col >= this.selected.startCol && col <= this.selected.endCol) {
					if (col > this.selected.col) {
						this.selected.endCol = col;
					}
					else if (col < this.selected.col) {
						this.selected.startCol = col;
					}
					else {
						this.selected.startCol = this.selected.endCol = col;
					}
				} else if (col > this.selected.endCol) {
					this.selected.endCol = col;
				}
				else if (col < this.selected.startCol) {
					this.selected.startCol = col;
				}
			}
		};
		
		if ([ninegrid.SELECTTYPE.AREA,ninegrid.SELECTTYPE.ROWS,ninegrid.SELECTTYPE.COLS].includes(this.type)) {
			$(".ng-table tbody.bindable", this.#owner.body).on("mousemove", onMouseMove);
			$(".ng-table tbody.bindable", this.#owner.body).on("mouseenter", onMouseEnter);
			$(".ng-table tbody.bindable", this.#owner.body).on("mouseleave", onMouseLeave);
		}
		
		$(document).on('mouseup', onMouseUp);
		
		this.rawIndex = this.#owner.dataManager.viewRecords.rawIndex;
	};
	
	
	
	selectArea = (row, col, row2, col2) => {
			
		var startRow	= Math.min(row, row2);
		var endRow		= Math.max(row, row2);
		var startCol	= Math.min(col, col2);
		var endCol		= Math.max(col, col2);
		
		$("tbody.bindable th,tbody.bindable td", this.#owner.body).each((index, td) => {
				
			var tr		= td.closest("tr");
			var tdRow	= (parseInt(td.dataset.row) * this.#owner.template.length + tr.sectionRowIndex % this.#owner.template.length);// + this.#owner.dataManager.viewRecords.rawIndex * this.#owner.template.length;;
			var tdCol	= parseInt(td.dataset.col);
			
			if (tdRow+td.rowSpan-1 >= startRow && tdRow <= endRow && tdCol+td.colSpan-1 >= startCol && tdCol <= endCol) {
				startRow	= Math.min(tdRow, startRow);
				startCol	= Math.min(tdCol, startCol);
				endRow		= Math.max(tdRow + td.rowSpan - 1, endRow);
				endCol		= Math.max(tdCol + td.colSpan - 1, endCol);
			}
		});

		//this.selected.startRow	= this.selected.startRow < 0 ? startRow : Math.min(this.selected.startRow, startRow);
		this.selected.startRow	= startRow;
		this.selected.endRow	= endRow;
		this.selected.startCol	= startCol;
		this.selected.endCol	= endCol;
		
		this.refresh();
	};
	
	
	selectCell = (row, col) => {

		this.selected.currentCol		= col;
		this.selected.currentMatrixRow	= row;
		this.selected.currentRow 		= parseInt(row / this.#owner.template.length);

		this.selectArea(row, col, row, col);
	};
	
	/**
	 * 그리드에 선택된 영역을 모두 해제합니다.
	 * 
	 * return : 없음
	 */
	clear = () => {
		this.selected.clear();
	};
	
	/**
	 * 선택된 영역의 Row 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get rows() {
		const arr = [];

		for (var i = this.selected.startRow; i <= this.selected.endRow; i++) {
			if (i >= 0) arr.push(parseInt(i / this.#owner.template.length));
		}
		
		return [...new Set(arr)];
	};
	
	/**
	 * 선택된 영역의 SubRow 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get subrows() {
		const arr = [];

		for (var i = this.selected.startRow; i <= this.selected.endRow; i++) {
			if (i >= 0) arr.push(parseInt(i % this.#owner.template.length));
		}
		
		return [...new Set(arr)];
	};
	
	/**
	 * 선택된 영역의 Column 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get cols() {
		const arr = [];
		const subrows = this.subrows;
		
		for (var i = this.selected.startCol; i <= this.selected.endCol; i++) {
			for (var subrow of subrows) {
				if ($(`[data-col="${i}"]`, this.#owner.template[subrow]).length > 0) {
					arr.push(i);
				}
			}
		}
		
		return [...new Set(arr)];
	};
	
	/**
	 * 선택된 영역의 컬럼명을 갖는 읽기전용 속성입니다.
	 */
	get binds() {
		const arr = [];
		const subrows = this.subrows;
		
		for (var i = this.selected.startCol; i <= this.selected.endCol; i++) {
			for (var subrow of subrows) {
				const cell = $(`[data-col="${i}"]`, this.#owner.template[subrow]);
				if (cell.length > 0 && cell[0].dataset.bind) {
					arr.push(cell[0].dataset.bind);
				}
			}
		}
		
		return [...new Set(arr)];
	};
	
	/**
	 * 선택된 영역의 첫번째 Cell 의 Row 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get firstRow() {
		return parseInt(this.selected.startRow / this.#owner.template.length);
	};
	/**
	 * 선택된 영역의 마지막 Cell 의 Row 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get lastRow() {
		return parseInt(this.selected.endRow / this.#owner.template.length);
	};
	/**
	 * 선택된 영역의 첫번째 Cell 의 Column 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get firstCol() {
		return this.selected.startCol;
	};
	/**
	 * 선택된 영역의 마지막 Cell 의 Column 인덱스를 갖는 읽기전용 속성입니다.
	 */
	get lastCol() {
		return this.selected.endCol;
	};
}
